import { render, staticRenderFns } from "./setMenu.vue?vue&type=template&id=361eaabe&"
import script from "./setMenu.vue?vue&type=script&lang=js&"
export * from "./setMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports